
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.995 5.998a5.997 5.997 0 11-11.994 0 5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M2.005 2.179h1.86c.307 0 .555.248.555.555v.427c0 .307.248.555.554.555h2.14M7.124 3.761a.648.648 0 101.296 0 .648.648 0 00-1.296 0zM5.167 11.089V9.596M5.192 9.49a.648.648 0 110-1.295.648.648 0 010 1.295zM11.061 10.978V6.62a.554.554 0 00-.554-.555h-.297M10.089 6.091a.647.647 0 10-1.295 0 .647.647 0 001.295 0zM2.06 6.512v3.396c0 .307.248.555.554.555h.297M3.032 10.437a.648.648 0 101.295 0 .648.648 0 00-1.295 0zM9.055 9.053H7.27a.554.554 0 00-.554.555v.182"}}),_c('path',{attrs:{"d":"M6.72 9.789a.648.648 0 100 1.295.648.648 0 000-1.295zM9.461 4.171v-1.28a.554.554 0 00-.555-.555H7.117M6.382 1.731a.648.648 0 100 1.295.648.648 0 000-1.295zM5.524 6.52l-.006.782c0 .306.249.554.555.554h1.378M7.571 7.831a.648.648 0 101.295 0 .648.648 0 00-1.295 0zM9.055 9.053a.648.648 0 101.295 0 .648.648 0 00-1.295 0z"}}),_c('path',{attrs:{"d":"M8.23 6.587V5.401c0-.307.248-.555.555-.555h1.351a.555.555 0 00.555-.554V3.079M10.665 3.002a.648.648 0 100-1.295.648.648 0 000 1.295zM1.989 5.531H5.78M5.857 5.531a.648.648 0 101.295 0 .648.648 0 00-1.295 0zM3.471 6.512v.823M3.471 7.412a.648.648 0 100 1.295.648.648 0 000-1.295zM5.949 4.354H3.197M3.05 4.354a.648.648 0 10-1.295 0 .648.648 0 001.295 0z"}})])])
          )
        }
      }
    